import http from '../http'

const EXPORT_GRAPHQL_URL: string = `${process.env.REACT_APP_API_URL}/graphql/export/xlsx`

export interface IExportGraphqlPayload {
  operationName: string
  query?: string
  variables?: Record<string, any>
}

export const exportGraphqlXlsx = (data: IExportGraphqlPayload) =>
  http.post(EXPORT_GRAPHQL_URL, { data })
